import { IsOnlineNow } from 'utils'
import FormattedDate from './FormattedDate'
import { LAST_SEEN_CONSTANTS } from './Constants'

const LastSeen = ({ lastOnline, listingPath }) => {
  const { LAST_SEEN_IN_FEW_DAYS_CUTOFF } = LAST_SEEN_CONSTANTS
  const displayAsOnline = IsOnlineNow(lastOnline, listingPath)

  const cutOffDate = new Date()
  cutOffDate.setDate(cutOffDate.getDate() - LAST_SEEN_IN_FEW_DAYS_CUTOFF)
  const seenInLastFewDays = new Date(lastOnline) >= cutOffDate

  let lastSeen = ''
  if (displayAsOnline) {
    lastSeen = <span>Online now</span>
  } else if (seenInLastFewDays) {
    lastSeen = (
      <span>
        Last seen <FormattedDate date={lastOnline} />
      </span>
    )
  } else {
    lastSeen = <span>Last seen over a week ago</span>
  }

  return <span>{lastSeen}</span>
}

export default LastSeen
